import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import type CK from '~/types/contentking';

import PageStatusBar, {
	PageStatusBarStatus,
} from '~/components/atoms/pageDetail/components/PageStatusBar';
import UnreliableResponseName from '~/components/names/UnreliableResponseName';

import usePageLastUnreliableResponse from '~/hooks/usePageLastUnreliableResponse';



const messages = defineMessages({
	label: {
		id: 'ui.pageDetail.statusMessage.unreliableCircumstances.label',
	},
});



type Props = {
	legacyUrlId: number,
	websiteId: CK.WebsiteId,
};

const UnreliableCircumstances: React.FC<Props> = (props) => {
	const {
		legacyUrlId,
		websiteId,
	} = props;

	const pageLastUnreliableResponse = usePageLastUnreliableResponse(legacyUrlId, websiteId);

	return (
		<PageStatusBar status={PageStatusBarStatus.Warning}>
			<FormattedMessage {...messages.label} />

			{pageLastUnreliableResponse !== null && (
				<span>
					{''} (<UnreliableResponseName reason={pageLastUnreliableResponse} />)
				</span>
			)}
		</PageStatusBar>
	);
};



export default UnreliableCircumstances;
